import Hero from "@/components/home/Hero";
import LocationCards from "@/components/home/LocationCards";
import FindYourPath from "@/components/home/FindYourPath";
import ImageStrip from "@/components/home/ImageStrip";
import PlayerPathway from "@/components/home/PlayerPathway";
import WhyLRG from "@/components/home/WhyLRG";
import ConversionCTA from "@/components/home/ConversionCTA";

const Home = () => (
  <div data-testid="home-page">
    <Hero />
    <LocationCards />
    <FindYourPath />
    <ImageStrip />
    <PlayerPathway />
    <WhyLRG />
    <ConversionCTA />
  </div>
);

export default Home;
